export enum SupportedCrossAppEventType {
  HTML_BACKGROUND = 'HTML_BACKGROUND',
  PIXEL_STREAM = 'PIXEL_STREAM'
}

export enum SupportActionEvents {
  ACTIVATE_AREA_ELEMENT = 'ACTIVATE_AREA_ELEMENT',
  HIDE_AREA_ELEMENTS = 'HIDE_AREA_ELEMENTS',
  SHOW_AREA_ELEMENTS = 'SHOW_AREA_ELEMENTS',
  HIDE_ALL_AREA_ELEMENTS = 'HIDE_ALL_AREA_ELEMENTS',
  SHOW_ALL_AREA_ELEMENTS = 'SHOW_ALL_AREA_ELEMENTS',
  INITIALIZE_AREA = 'INITIALIZE_AREA',
  CREATE_TRACKING_EVENT = 'CREATE_TRACKING_EVENT'
}

export interface ICrossAppMessageData {
  action: SupportActionEvents;
  areaElementIds?: string[];
  htmlBackgroundElementIds?: string[];
  metadata?: string;

  // Add additional properties as needed.
  [key: string]: unknown;
}

export interface ICrossAppMessage {
  type: SupportedCrossAppEventType;
  data: ICrossAppMessageData;
  source?: string;
  timestamp?: number;
}

export interface ICrossAppMessageHandler {
  type: string;
  callback: (message: ICrossAppMessage) => void;
}
